import { render } from "./IdentityResources.vue?vue&type=template&id=91ffaff4"
import script from "./IdentityResources.vue?vue&type=script&lang=js"
export * from "./IdentityResources.vue?vue&type=script&lang=js"

import "./IdentityResources.vue?vue&type=style&index=0&id=91ffaff4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__